import React from 'react'
import SectionWrapper from '../../Components/SectionWrapper'
import { SectionHeading } from '../../Styles/style'
import { Grid, Typography } from '@mui/material'
import tokenomicsImg from '../../../assets/tokenomics.png'
import { useTheme } from '@emotion/react'
import ethscan from '../../../assets/eth-scan.png'
import uniswap from '../../../assets/uniswap.png'
import dextool from '../../../assets/dextool.png'

const Tokenomics = () => {
    const theme = useTheme();
  return (
    <SectionWrapper>
        <Grid xs={12}>
            <SectionHeading variant="h1">Tokenomics</SectionHeading>
        </Grid>
        <Grid container>
            <Grid xs={12} md={4} sx={{textAlign: 'center',px:2, mb:3}}>
                <img src={tokenomicsImg} alt="Tokenomics-image" style={{width: '100%', height: 'auto'}}/>
            </Grid>
            <Grid xs={12} md={8} >
                <Grid container sx={{p:3, backgroundColor: theme.bgSecondary}}>
                    <Grid xs={6}>
                        <Typography variant="h5" color={theme.textPrimary}>Name</Typography>
                    </Grid>
                    <Grid xs={6} sx={{textAlign:'right'}}>
                        <Typography variant="h5" color={theme.textPrimary}>PEPPER</Typography>
                    </Grid>
                    <Grid xs={6}>
                        <Typography variant="h5" color={theme.textPrimary}>Symbol</Typography>
                    </Grid>
                    <Grid xs={6} sx={{textAlign:'right'}}>
                        <Typography variant="h5" color={theme.textPrimary}>$PEPPER</Typography>
                    </Grid>
                    <Grid xs={6}>
                        <Typography variant="h5" color={theme.textPrimary}>Supply</Typography>
                    </Grid>
                    <Grid xs={6} sx={{textAlign:'right'}}>
                        <Typography variant="h5" color={theme.textPrimary}>TBA</Typography>
                    </Grid>
                    <Grid xs={6}>
                        <Typography variant="h5" color={theme.textPrimary}>Tax</Typography>
                    </Grid>
                    <Grid xs={6} sx={{textAlign:'right'}}>
                        <Typography variant="h5" color={theme.textPrimary}>2/2</Typography>
                    </Grid>
                    
                    {/* <Grid xs={12} container sx={{mt:4}}>
                        <Grid xs={5} sx={{p:1,backgroundColor: theme.hoverPrimary}}>
                            <Typography variant="h5" color={theme.textPrimary}>90%</Typography>
                            <Typography variant="h5" color={theme.textPrimary}>Liquidity</Typography>
                        </Grid>
                        <Grid xs={4} sx={{p:1,backgroundColor: 'red'}}>
                            <Typography variant="h5" color={theme.textPrimary}>6%</Typography>
                            <Typography variant="h5" color={theme.textPrimary}>Cex Listing</Typography>
                        </Grid>
                        <Grid xs={3} sx={{p:1,backgroundColor: theme.hoverSecandary}}>
                            <Typography variant="h5" color={theme.textPrimary}>4%</Typography>
                            <Typography variant="h5" color={theme.textPrimary}>Pepe Airdrop</Typography>
                        </Grid>
                    </Grid> */}
                </Grid>
                
                <Grid container sx={{mt:3, px:3, py:2, backgroundColor: theme.bgSecondary}}>
                    <Grid xs={6}>
                        <Typography variant="h5" color={theme.textPrimary}>Contract</Typography>
                    </Grid>
                    <Grid xs={6} sx={{textAlign:'right'}}>
                        <Typography variant="h5" color={theme.textPrimary} sx={{wordBreak:"break-all"}}>0x24ABCa46E6bF3e18b870F9F5Cc1A361ECE13C68d</Typography>
                    </Grid>
                </Grid>
                <Grid container sx={{mt:3}}>
                    <img src={ethscan} alt="eth-scan" style={{marginRight:15, width: '100%', maxWidth: 150, height: 'auto'}} />
                    <img src={uniswap} alt="uniswap" style={{marginRight:15, width: '100%', maxWidth: 150, height: 'auto'}} />
                    <img src={dextool} alt="dextool" style={{width: '100%', maxWidth: 150, height: 'auto'}}/>
                </Grid>
            </Grid>
        </Grid>
    </SectionWrapper>
  )
}

export default Tokenomics